import { FormikProps } from 'formik';
import { BaseModalProps, Button, ModalContentWrapper, TextInput } from 'ui';

export interface ClientFormValues {
  name: string;
  phone_number: string;
  email: string;
}

interface ClientModalProps extends BaseModalProps {
  formik: FormikProps<ClientFormValues>;
  isSubmitting: boolean;
  isEditMode?: boolean;
}

export const ClientModal = ({
  open,
  onClose,
  formik,
  isSubmitting,
  isEditMode,
}: ClientModalProps) => {
  const buttonText = isEditMode ? 'Update client' : 'Create client';
  const title = isEditMode ? 'Edit client' : 'Add new client';

  return (
    <ModalContentWrapper open={open} onClose={onClose} title={title}>
      <form onSubmit={formik.handleSubmit} className="flex flex-col gap-4 mt-2">
        <TextInput
          name="name"
          label="Name"
          value={formik.values.name}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          required
          error={(formik.touched.name && formik.errors.name) || undefined}
          autoFocus
          placeholder="Enter client name"
        />
        <TextInput
          name="phone_number"
          label="Phone number"
          value={formik.values.phone_number}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={(formik.touched.phone_number && formik.errors.phone_number) || undefined}
          placeholder="Enter phone number"
        />
        <TextInput
          name="email"
          label="Email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          type="email"
          error={(formik.touched.email && formik.errors.email) || undefined}
          placeholder="Enter email address"
        />
        <div className="flex justify-end gap-2 mt-4">
          <Button type="button" variant="secondary" onClick={onClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="primary"
            loading={isSubmitting}
            disabled={!formik.isValid || !formik.dirty}
          >
            {buttonText}
          </Button>
        </div>
      </form>
    </ModalContentWrapper>
  );
};
